export const THINKING_VERBS = [
    'Accomplishing',
    'Actioning',
    'Actualizing',
    'Baking',
    'Brewing',
    'Calculating',
    'Cerebrating',
    'Churning',
    'Coalescing',
    'Cogitating',
    'Computing',
    'Conjuring',
    'Considering',
    'Cooking',
    'Crafting',
    'Creating',
    'Crunching',
    'Deliberating',
    'Determining',
    'Doing',
    'Effecting',
    'Finagling',
    'Forging',
    'Forming',
    'Generating',
    'Hatching',
    'Herding',
    'Honking',
    'Hustling',
    'Ideating',
    'Inferring',
    'Manifesting',
    'Marinating',
    'Moseying',
    'Mulling',
    'Mustering',
    'Musing',
    'Noodling',
    'Percolating',
    'Pondering',
    'Processing',
    'Puttering',
    'Reticulating',
    'Ruminating',
    'Schlepping',
    'Shucking',
    'Simmering',
    'Smooshing',
    'Spinning',
    'Stewing',
    'Synthesizing',
    'Thinking',
    'Transmuting',
    'Vibing',
    'Working'
] as const

export const VERB_ROTATION_INTERVAL_MS = 2500

export function getRandomVerb(): string {
    return THINKING_VERBS[Math.floor(Math.random() * THINKING_VERBS.length)]
}
